import axios from 'axios';
import ApiUrl from './config';
import { RoundRobinStandingModel } from './categoryDrawApi';

export type MatIdleMode = 'Wait' | 'Upcoming' | 'Bracket';

export interface MatDisplaySetting {
  matNumber: number;
  idleMode: MatIdleMode;
  tournamentId?: number | null;
  ageCategoryInTournamentId?: number | null;
  weightCategoryInTournamentId?: number | null;
}

export interface MatIdleMatchRow {
  id: number;
  round: number;
  order: number;
  roundLabel: string;
  homeName: string;
  awayName: string;
  finished: boolean;
  isHomeWinner?: boolean | null;
}

export interface MatIdleRoundView {
  title: string;
  matches: MatIdleMatchRow[];
}

export interface MatIdleGroupView {
  groupIndex: number;
  standings: RoundRobinStandingModel[];
  matches: MatIdleMatchRow[];
}

export interface MatIdlePodiumPlace {
  place: number;
  name: string;
}

export interface MatIdleView {
  matNumber: number;
  idleMode: MatIdleMode;
  tournamentName?: string | null;
  categoryLabel?: string | null;
  format?: string | null;
  upcoming: MatIdleMatchRow[];
  standings: RoundRobinStandingModel[];
  groups: MatIdleGroupView[];
  rounds: MatIdleRoundView[];
  podium: MatIdlePodiumPlace[];
}

export async function fetchMatDisplaySettings(): Promise<MatDisplaySetting[]> {
  const { data } = await axios.get<MatDisplaySetting[]>(`${ApiUrl}/api/MatDisplay/GetSettings`);
  return data;
}

export async function updateMatDisplaySetting(
  request: MatDisplaySetting
): Promise<MatDisplaySetting> {
  const { data } = await axios.put<MatDisplaySetting>(
    `${ApiUrl}/api/MatDisplay/UpdateSetting`,
    request
  );
  return data;
}

export async function fetchMatIdleView(matNumber: number): Promise<MatIdleView> {
  const { data } = await axios.get<MatIdleView>(`${ApiUrl}/api/MatDisplay/GetIdleView`, {
    params: { matNumber },
  });
  return {
    ...data,
    upcoming: data.upcoming ?? [],
    standings: data.standings ?? [],
    groups: data.groups ?? [],
    rounds: data.rounds ?? [],
    podium: data.podium ?? [],
  };
}
